"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.failedStatusSchema = exports.runningStatusSchema = exports.pendingStatusSchema = exports.verifiedStatusSchema = exports.waitingForUploadStatusSchema = void 0;
exports.jobWaitingForUploadStatus = jobWaitingForUploadStatus;
exports.jobVerfiedStatus = jobVerfiedStatus;
exports.jobPendingStatus = jobPendingStatus;
exports.jobRunningStatus = jobRunningStatus;
exports.jobFailedStatus = jobFailedStatus;
exports.createCompleteStatusSchema = createCompleteStatusSchema;
exports.jobCompleteStatus = jobCompleteStatus;
exports.setStatusForJob = setStatusForJob;
exports.setJobPdfUid = setJobPdfUid;
exports.setJobWorkflowId = setJobWorkflowId;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const credit_1 = require("../credit");
// Schema/functions for job status
/**
 * Status for any job that requires an upload
 *
 * For example, the `extractComponentsFromDatasheet` job requires an upload from user to start the job
 */
exports.waitingForUploadStatusSchema = zod_1.default.object({
    type: zod_1.default.literal("waiting-for-upload"),
    uploadLocation: zod_1.default.string(),
});
function jobWaitingForUploadStatus(uploadLocation) {
    return {
        type: "waiting-for-upload",
        uploadLocation,
    };
}
/**
 * Status for any job that requires some verification
 *
 * For example, in `extractComponentsFromDatasheet` job, after user uplod a datasheet, we perform a signature
 * check on the uploaded datasheet, and will only start the Temporal workflow to process the datasheet after it's
 * verified.
 */
exports.verifiedStatusSchema = zod_1.default.object({
    type: zod_1.default.literal("verified"),
    verifiedLocation: zod_1.default.string(),
});
function jobVerfiedStatus(verifiedLocation) {
    return {
        type: "verified",
        verifiedLocation,
    };
}
/**
 * General status for any job that's pending to be run
 */
exports.pendingStatusSchema = zod_1.default.object({
    type: zod_1.default.literal("pending"),
});
function jobPendingStatus() {
    return {
        type: "pending",
    };
}
/**
 * General status for any job that's running, usually means we have started a Temporal workflow for it
 */
exports.runningStatusSchema = zod_1.default.object({
    type: zod_1.default.literal("running"),
});
function jobRunningStatus() {
    return {
        type: "running",
    };
}
/**
 * General status for any failed job
 */
exports.failedStatusSchema = zod_1.default.object({
    type: zod_1.default.literal("failed"),
    reason: zod_1.default.string(),
});
function jobFailedStatus(reason) {
    return {
        type: "failed",
        reason,
    };
}
/**
 * Helper function to create a `complete` status for a job
 */
function createCompleteStatusSchema(dataSchema) {
    return zod_1.default.object({
        type: zod_1.default.literal("complete"),
        jobData: dataSchema,
        credit: credit_1.CreditTrace.optional(),
    });
}
// NOTE: this weirdly typed function is a result of the somewhat annoying fact that zod can't express parametric types.
// This is really a structural type, which is fine, because the compiler will keep us honest at call sites.
function jobCompleteStatus(jobData, credit) {
    return {
        type: "complete",
        jobData,
        credit,
    };
}
function setStatusForJob(job, status) {
    return {
        ...job,
        jobStatus: status,
    };
}
function setJobPdfUid(job, pdfUid) {
    return {
        ...job,
        pdfUid,
    };
}
function setJobWorkflowId(job, workflowId) {
    return {
        ...job,
        workflowId,
    };
}
//# sourceMappingURL=status.js.map